/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_HqInputs */

const vi_shop_home_hq = /** @type {(inputs: Shop_Home_HqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trụ sở`)
};

/**

* @param {Shop_Home_HqInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hq = /** @type {((inputs?: Shop_Home_HqInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_HqInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hq(inputs)
});